$('.grid-slider').each((i, el) => {
	const $el = $(el);
	const $sliderEl = $el;
	const { nextArrow, prevArrow } = Globals.sliders;
	const numSlides = $sliderEl.find('.slide').length;
	const $filler = $sliderEl.find('.block-filler-card');
	const $controls = $sliderEl.next('.js-slider-controls');

	let config = {
		dots: numSlides <= 6,
		slidesToShow: 1,
		centerMode: true,
		centerPadding: '20px',
		mobileFirst: true,
		nextArrow,
		prevArrow,
		appendArrows: $controls,
		appendDots: $controls,
		responsive: [
			{
				breakpoint: 768,
				settings: 'unslick'
			}
		]
	};

	const $slider = $sliderEl.slick(config);

	// Remove any filler cards
	if ($filler.length) {
		const lastSlide = $sliderEl.find('.slide:not(.slick-cloned)').length;
		$slider.slick('slickRemove', lastSlide);
	}

	// Remove accessibility attributes if slick has not been initialized (I.e. desktop "unslick")
	if ($slider.find('.slick-track').length === 0) {
		$slider.find('> *').removeAttr('aria-describedby role tabindex aria-hidden');
		$slider.find('a[tabindex="-1"], button[tabindex="-1"]').removeAttr('tabindex');
	}

});
